import {
    ResponsiveContainer,
    ComposedChart,
    Bar,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    CartesianGrid,
    Label
} from 'recharts';
import { Box, Typography } from '@mui/material';
import { filterBarKeysIfNoData, formatGraphAxis, BarGraphTooltip, CustomLegend, formatTicker } from '../utils/graph-utils';
import { composedChartMargin, barGraphFontSize, labelOffSet, legendHeight, legendIconSize, responsiveContainerHeight, groupColors, chartOffset } from '../constants/graph-constants';

const GroupBarChart = ({ data, type, year, unit, companyName, groupArray }) => {

    const filteredBarKeys = filterBarKeysIfNoData(groupArray, data);
    const sortedAndFilteredBarKeys = filteredBarKeys?.slice().sort((a, b) => a.localeCompare(b))

    return (
        <Box sx={{ width: '100%', height: '100%' }}>
            <Typography variant="h6" align="center" gutterBottom>
                {companyName} {type} {year} per Group
            </Typography>
            <ResponsiveContainer width="100%" height={responsiveContainerHeight}>
                <ComposedChart data={data} margin={composedChartMargin}>
                    <CartesianGrid stroke="#f5f5f5" />
                    <XAxis
                        dataKey="month"
                        fontSize={barGraphFontSize}
                    >
                        <Label value="Month" position='insideBottom' offset={labelOffSet} fontSize={barGraphFontSize} />
                    </XAxis>
                    <YAxis
                        fontSize={barGraphFontSize}
                        domain={([dataMin, dataMax]) => { const yAxisDisplayMax = formatGraphAxis(dataMax, dataMin); return yAxisDisplayMax }}
                        tickFormatter={value => formatTicker(value)}
                    >
                        <Label value={unit} angle={-90} position={'insideLeft'} offset={chartOffset} fontSize={barGraphFontSize} />
                    </YAxis>
                    <Tooltip content={<BarGraphTooltip />} />
                    <Legend content={<CustomLegend variant={'group'} />} iconSize={legendIconSize} verticalAlign='top' height={legendHeight} />
                    {sortedAndFilteredBarKeys?.map(barKey => (
                        <Bar
                            key={barKey}
                            dataKey={barKey}
                            fill={groupColors[barKey] || '#ccc'}
                            name={barKey}
                        />
                    ))}
                    <Line
                        type="monotone"
                        dataKey="total"
                        stroke="#000"
                        strokeWidth={2}
                        dot={false}
                        name="Total"
                    />
                </ComposedChart>
            </ResponsiveContainer>
        </Box>
    )
};


export default GroupBarChart;